import { useRestaurantDetails } from "../context/RestaurantDetailsContext";
import { getRestaurantTimezone } from "../helper/dateTimeUtils";

export function useRestaurantConfig() {
  const { restaurantDetails } = useRestaurantDetails() || {};

  const locale = restaurantDetails?.locale || "en-IN";
  const timezone = getRestaurantTimezone(restaurantDetails?.timezone);
  const features = restaurantDetails?.features || {};

  return {
    locale,
    timezone,
    features,
    restaurantId: restaurantDetails?._id,
    gstRate: restaurantDetails?.gstRate ?? 0,
  };
}
